import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import _possibleConstructorReturn from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js";
import _inherits from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/inherits.js";
import "core-js/modules/es6.regexp.split.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import BaseModel from "./BaseModel";
var User = /*#__PURE__*/function (_BaseModel) {
  function User() {
    _classCallCheck(this, User);
    return _callSuper(this, User, arguments);
  }
  _inherits(User, _BaseModel);
  return _createClass(User, [{
    key: "firstName",
    value: function firstName() {
      return this.get('name').split(' ')[1];
    }
  }]);
}(BaseModel);
export default User;